import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Landing from '../pages/Landing'
import Dashboard from '../pages/Dashboard'
import Products from '../pages/Products'
import Categorys from '../pages/Categorys'
import Marks from '../pages/Marks'
import SubCategorys from '../pages/SubCategorys'
import Marking from '../pages/Marking'
import Carts from '../pages/Carts'
import Financial from '../pages/Financial'
import Pages from '../pages/Pages'
import Clients from '../pages/Clients'
import ButtonPages from '../pages/ButtonPages'
import Facebook from '../pages/Facebook'
import Instagram from '../pages/Instagram'
import GoogleMerchantCenter from '../pages/GoogleMerchantCenter'
import PrivateRoute from '../pages/PrivateRoute'
import SallesOrder from '../pages/SallesOrder'
import Banners from '../pages/Banners'
import Salle from '../pages/Salle'
import MercadoLivre from '../pages/MercadoLivre'


const AppStack = () => {
    return (

        <BrowserRouter>

            <Routes>
                <Route path='/' element={<Landing/>}/>
                <Route path='/dashboard' element={<PrivateRoute><Dashboard/></PrivateRoute>}/>
                <Route path='/dashboard/products' element={<PrivateRoute><Products/></PrivateRoute>}/>
                <Route path='/dashboard/salle' element={<PrivateRoute><Salle/></PrivateRoute>}/>
                <Route path='/dashboard/marking' element={<PrivateRoute><Marking/></PrivateRoute>}/>
                <Route path='/dashboard/categorys' element={<PrivateRoute><Categorys/></PrivateRoute>}/>
                <Route path='/dashboard/marks' element={<PrivateRoute><Marks/></PrivateRoute>}/>

                <Route path='/dashboard/sub/categorys' element={<PrivateRoute><SubCategorys/></PrivateRoute>}/>
                <Route path='/dashboard/cart/loss' element={<PrivateRoute><Carts/></PrivateRoute>}/>
                <Route path='/dashboard/financial' element={<PrivateRoute><Financial/></PrivateRoute>}/>
                <Route path='/dashboard/pages' element={<PrivateRoute><Pages/></PrivateRoute>}/>
                <Route path='/dashboard/clients' element={<PrivateRoute><Clients/></PrivateRoute>}/>
                <Route path='/dashboard/button' element={<PrivateRoute><ButtonPages/></PrivateRoute>}/>
                <Route path='/dashboard/sales/order' element={<PrivateRoute><SallesOrder/></PrivateRoute>}/>
                <Route path='/dashboard/social/facebook' element={<PrivateRoute><Facebook/></PrivateRoute>}/>
                <Route path='/dashboard/social/instagram' element={<PrivateRoute><Instagram/></PrivateRoute>}/>
                <Route path='/dashboard/social/google' element={<PrivateRoute><GoogleMerchantCenter/></PrivateRoute>}/>
                <Route path='/dashboard/marketing/banners' element={<PrivateRoute><Banners/></PrivateRoute>}/>
                <Route path='/dashboard/mercadolivre' element={<PrivateRoute><MercadoLivre/></PrivateRoute>}/>

            </Routes>

        </BrowserRouter>
    )
}

export default AppStack